const rowStyles = { gap: 20, flexWrap: 'nowrap' }

const widthStyles = { width: '100%' }

export { rowStyles, widthStyles }
